import  React from 'react'
import { Alert } from 'react-bootstrap'

export interface ScheduleInstructionsProps {
    title: string
    helpLink: string
    showEarningsAlert?: boolean
    hideApportionmentNote?: boolean
}

export const ScheduleInstructions: React.FC<ScheduleInstructionsProps> = (props: ScheduleInstructionsProps) => (
  <>
    <h2 className="mt-3">{props.title}</h2>
    <h5><a href={props.helpLink} target="_blank" rel="noreferrer">For information on how to complete this schedule click here.</a></h5>
    <p className="mt-3">
      <b>Please note:</b>
      {' '}
      you may be asked to upload supporting documents. As you add or remove items, the documents required to be attached may change.
      <br />
      The required documents should be uploaded in the Supporting Documents section at the end of the applicant form once you have completed all your Expense and Export Earning Schedules.
      <br />
      <b>You must click the "Save & continue" button after entering data or you will lose the data.</b>
    </p>
    <p className="mt-3" style={{ display: props.hideApportionmentNote ? 'none' : '' }}>The basis for any apportionment of expenses should be entered in the Notes field.</p>
    <div className="mt-3 mb-3" style={{ display: props.showEarningsAlert ? '' : 'none' }}>
      <Alert className="emdg-page-alerts">
        If you have more than 50 export earnings transactions this grant year, you can:
        <ul>
          <li>provide details of individual transactions for 1 month (ie enter the date in the ‘Date earnings received. Actual date’ column), and</li>
          <li>provide monthly totals for other months (ie use 'Date earnings received. Month only’ column)</li>
        </ul>
        <p className="mt-3">
          Enter a date in either 'Actual date' or 'Month only'. Not BOTH.
        </p>
      </Alert>
    </div>
  </>
)
